import {auth} from '@/config/firebase';
import {
  getAllAirportNoteData,
  getAllFirNotams,
  getAllNotams,
  getAllSitmapNotes,
  getFirData
} from '@/firebase/common';
import {getAllDataStatus} from '@/firebase/data-status';
import {getAllDiversion} from '@/firebase/diversion';
import {getAllAircraftBasicData, stationOfAirline} from '@/firebase/flight';
import {allAirlinesWhitelistRef} from '@/firebase/radar';
import {getAllSystemWatchList} from '@/firebase/system-watch-list';
import {allWatchList} from '@/firebase/watch-list';
import {useAppDispatch} from '@/hooks/redux';
import {setAirlineStations} from '@/redux/slice/airportSlice';
import {
  setAirportNoteReady,
  setDiversion,
  setSystemWatchList,
  setWatchList
} from '@/redux/slice/appSlice';
import {setToken} from '@/redux/slice/userSlice';
import {getFeConfig} from '@/services/config';
import useFleet from '@/stores/fleet';
import {checkNotamEffective} from '@/utils/notam';
import * as turf from '@turf/turf';
import {get, onValue} from 'firebase/database';
import {useEffect} from 'react';
import {useAuthState} from 'react-firebase-hooks/auth';

export const SyncData = () => {
  const [user] = useAuthState(auth);
  const dispatch = useAppDispatch();
  const setFleetTypes = useFleet((state) => state.setFleetTypes);

  const getAirlineStation = async () => {
    const airline = localStorage.getItem('airline') ?? '';
    const data = await stationOfAirline(airline);
    dispatch(setAirlineStations(data));
    window.airlineStation = data;
    return data;
  };

  const getWatchList = async () => {
    const airline = localStorage.getItem('airline') ?? '';
    onValue(allWatchList(airline), (snapshot) => {
      const data = snapshot.val();
      const result: any = {};
      for (const key in data) {
        result[data[key]] = key;
      }
      dispatch(setWatchList(result));
    });
  };

  const getDiversion = async () => {
    const airline = localStorage.getItem('airline') ?? '';
    onValue(getAllDiversion(airline), (snapshot) => {
      const data = snapshot.val();

      dispatch(setDiversion(data ?? {}));
    });
  };

  const getSystemWatchList = async () => {
    const airline = localStorage.getItem('airline') ?? '';
    onValue(getAllSystemWatchList(airline), (snapshot) => {
      const data = snapshot.val();
      const result: any = {};
      for (const key in data) {
        result[data[key]] = key;
      }
      dispatch(setSystemWatchList(result));
    });
  };

  const getNotification = async () => {
    // onValue(getAllNotification(), (snapshot) => {
    //   if (window?.skipListenNotification) return;
    //   const data = snapshot.val();
    //   if (!data) return;
    //   const result: any = Object.keys(data)
    //     ?.map((key) => {
    //       return {
    //         ...data[key],
    //         firebaseKey: key
    //       };
    //     })
    //     ?.filter((item: any) => item.message)
    //     ?.sort((a: any, b: any) => {
    //       return (
    //         new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    //       );
    //     });
    //   if (result.length > 100) result.length = 100;
    //   dispatch(setAlertData(result ?? []));
    // });
  };

  const getAllPirep = async () => {
    try {
      const refData = await getAllSitmapNotes();
      const response = refData?.data ?? {};
      // console.log('Total pireps', Object.keys(response).length);
      const sitmapNoteData = Object.keys(response).map((key) => {
        return {
          ...response[key],
          id: key
        };
      });
      window.pirep = sitmapNoteData;
      const data: any = sitmapNoteData
        ?.filter((item) => item?.noteCount > 0)
        ?.map((item) => ({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [
              parseFloat(item.longitude ?? ''),
              parseFloat(item.latitude ?? '')
            ]
          },
          properties: {
            id: item._id,
            textColor: '#ffffff',
            ...item,
            noteCount: item.noteCount > 1 ? item.noteCount : '',
            content: false
          }
        }));
      window.updateData({
        event: 'pirep',
        data
      });
    } catch (e) {
      // console.error('error get pirep', e);
    }
  };

  const getAllNotamFIR = async () => {
    try {
      const notams = await getAllFirNotams();
      const response: any = notams?.data ?? {};
      // console.log('Total notams fir', Object.keys(response).length);
      const data: any = [];
      Object.keys(response).forEach((key: any) => {
        const notams = Object.keys(response[key]);
        notams.forEach((notamKey: any) => {
          const notam = response[key][notamKey];
          data.push({
            ...notam,
            airport: key,
            isEffective: checkNotamEffective(notam, undefined),
            id: notam.uuid
          });
        });
      });
      window.notamFir = data;
      const notamInTheMap = data.filter((item: any) => {
        if (!item?.coordinate) {
          return false;
        }
        if (item?.isEffective && item?.relevant) {
          return true;
        }
        return false;
      });
      const notamData = notamInTheMap.map((i: any) => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [
            parseFloat(i.coordinate[1]),
            parseFloat(i.coordinate[0])
          ]
        },
        properties: {
          id: i.id,
          ...i
        }
      }));
      const notamFirData: any = [];
      notamInTheMap
        .filter((i: any) => i?.area ?? i?.coordinate)
        .forEach((i: any) => {
          try {
            let area: any = i.area;
            if (!area && i?.coordinate) {
              area = turf.circle(
                [parseFloat(i.coordinate[1]), parseFloat(i.coordinate[0])],
                parseInt(i.radius)
              );
            }
            notamFirData.push({
              type: 'Feature',
              properties: {
                type: 'fir-notam',
                id: i.notamID,
                ...i,
                colorOpacity: 0.05,
                borderOpacity: 0.1,
                color: '#E6BB07',
                borderColor: '#E6BB07'
              },
              geometry: area.geometry
            } as any);
          } catch (e) {}
        });
      if (!window.mapData) {
        window.mapData = {};
      }
      window.mapData.notamFir = notamFirData;
      window.mapData.notamFirText = notamData;
      window.updateData({
        event: 'notamFir',
        data: notamFirData
      });
      window.updateData({
        event: 'notamFirText',
        data: notamData
      });
    } catch (e) {
      // console.error('error get all notam fir', e);
    }
  };

  const getAllNotam = async () => {
    try {
      const notams = await getAllNotams();
      const response: any = notams?.data ?? {};
      // console.log('Total notams', Object.keys(response).length);
      const data: any = [];
      window.notamByAirport = {};
      Object.keys(response).forEach((key: any) => {
        if (!window.notamByAirport[key]) {
          window.notamByAirport[key] = [];
        }
        const notams = Object.keys(response[key]);
        notams.forEach((notamKey: any) => {
          const notam = response[key][notamKey];
          const item = {
            ...notam,
            airport: key,
            isEffective: checkNotamEffective(notam, undefined),
            id: notam.uuid
          };
          data.push(item);
          window.notamByAirport[key].push(item);
        });
      });
      window.notam = data;
      const notamData = data
        .filter((item: any) => {
          if (!item?.coordinate) {
            return false;
          }
          if (item?.isEffective && item?.category === 'Obstacles') {
            return true;
          }
          return false;
        })
        .map((i: any) => ({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [
              parseFloat(i.coordinate[1]),
              parseFloat(i.coordinate[0])
            ]
          },
          properties: {
            id: i.id,
            ...i
          }
        }));
      if (!window.mapData) {
        window.mapData = {};
      }
      window.mapData.notam = notamData;
      window.updateData({
        event: 'notam',
        data: notamData
      });
    } catch (e) {
      // console.error('error get all notam', e);
    }
  };

  // const airport = airports[i];
  //   const noteData = notes[airport];
  //   Object.keys(noteData).forEach((noteId: string) => {
  //     const content = noteData[noteId];
  //     writeAirportNote({
  //       id: noteId,
  //       airport,
  //       content
  //     });
  //   });

  const getAirportNotes = async () => {
    const response = await getAllAirportNoteData();
    const data = response?.data ?? {};
    const finalData: any = {};
    Object.keys(data).forEach((airport: string) => {
      const noteData = data[airport];
      const aipByAirport: Array<{
        id: string;
        airport: string;
        content: string;
      }> = [];
      Object.keys(noteData).forEach((noteId: string) => {
        const content = noteData[noteId];
        aipByAirport.push({
          id: noteId,
          airport,
          content
        });
      });
      finalData[airport] = aipByAirport;
    });
    window.aipByAirport = finalData;
    dispatch(setAirportNoteReady(true));
  };

  const getAllFir = async () => {
    try {
      const firData = await getFirData();
      const firs: any = (firData ?? [])
        .filter((i: any) => i?.area)
        .map((i: any) => ({...i, area: JSON.parse(i.area)}));
      window.firs = firs;
      const data: any = firs.map((i: any) => {
        return {
          type: 'Feature',
          properties: {
            id: i.fir,
            colorOpacity: 0.05,
            borderOpacity: 0.15,
            color: '#17B1E3',
            borderColor: '#17B1E3'
          },
          geometry: {
            type: 'Polygon',
            coordinates: [i.area]
          }
        } as any;
      });
      const dataIcon = firs.map((i: any) => {
        const firInfo = i;
        const features = turf.points(firInfo?.area);
        const center = turf.centerOfMass(features);
        return {
          type: 'Feature',
          properties: {
            id: i.fir,
            textOpacity: 1,
            textColor: '#17B1E3'
          },
          geometry: center.geometry
        } as any;
      });
      if (!window.mapData) {
        window.mapData = {};
      }
      window.mapData.firLayer = data;
      window.mapData.firIcon = dataIcon;
      window.updateData({
        event: 'firLayer',
        data
      });
      window.updateData({
        event: 'firIcon',
        data: dataIcon
      });
    } catch (e) {
      console.error('error get all fir', e);
    }
  };

  const getWeather = async () => {
    window?.initWeather('');
  };

  const getAirlineWhiteList = async () => {
    const snapshot = await get(allAirlinesWhitelistRef());
    window.airlineWhiteList = snapshot.val();
    const fleet = window.airlineWhiteList.TGW.fleet ?? [];
    setFleetTypes(fleet);
  };

  useEffect(() => {
    if (!user) return;
    void getAirlineStation();
    void getAllAircraftBasicData();
    void getWatchList();
    void getDiversion();
    void getSystemWatchList();
    void getNotification();
    void getAirlineWhiteList();
    void user.getIdToken().then(async (token) => {
      dispatch(setToken(token));
      void getFeConfig();
      setTimeout(() => {
        void getAllPirep();
        void getAllNotamFIR();
        void getAllNotam();
        void getAirportNotes();
        void getWeather();
        void getAllFir();
        void getAllDataStatus();
      }, 3000);
    });
  }, [user]);

  return <></>;
};

export default SyncData;
